export const apiUrl = `https://api.itstaste.com/api`;
export const defaultPagination = 20;
export const perPageList = [20, 50, 100];
export const is_live = true;

export const APP_NAME = 'nimble';
export const APP_PORTAL = 'staff';
export const APP_TENANT = 'nimble';
export const APP_PUSHER_KEY = '6bd4b77d06f0e4c29db8'
export const APP_SAGE_KEY = '7HyfIe66G922jQlQEv0UVdtY7XleXoe3'
export const APP_SAGE_AUTH_URL = `https://id.sage.com/authorize?audience=s200ukipd/sage200`
export const SUPPORT_APP_URL = 'https://support.souqbox.io'
export const AI_CHAT_API_URL = `https://dev-ai-chat-api.itstaste.com/api/v1`;